import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { CIRCLE_ROUTES as CIRCLE_ROUTE_CONSTANTS } from '../../route-constants';

const CircleRoutesWrapper = lazy(() => import('@~/pages/circle'));
const CircleHomePage = lazy(() => import('@~/pages/circle/home/home'));
const CircleGame = lazy(() => import('@~/pages/circle/game/game'));
const MathgymWorkout = lazy(() => import('@~/pages/circle/workout/workout'));
const CircleLeaderboard = lazy(() => import('@~/pages/circle/leaderboard/leaderboard'));
const MathgymDownloadApp = lazy(
  () => import('@~/pages/circle/download-app/download-app'),
);

export const CIRCLE_ROUTES: RouteObject = {
  path: CIRCLE_ROUTE_CONSTANTS.ROOT.PATH,
  element: <CircleRoutesWrapper />,
  handle: {
    pageName: CIRCLE_ROUTE_CONSTANTS.ROOT.NAME,
  },
  children: [
    {
      path: CIRCLE_ROUTE_CONSTANTS.HOME.RELATIVE_PATH,
      element: <CircleHomePage />,
      handle: {
        pageName: CIRCLE_ROUTE_CONSTANTS.HOME.NAME,
      },
    },
    {
      path: CIRCLE_ROUTE_CONSTANTS.GAME.RELATIVE_PATH,
      element: <CircleGame />,
      handle: {
        pageName: CIRCLE_ROUTE_CONSTANTS.GAME.NAME,
      },
    },
    {
      path: CIRCLE_ROUTE_CONSTANTS.WORKOUT.RELATIVE_PATH,
      element: <MathgymWorkout />,
      handle: {
        pageName: CIRCLE_ROUTE_CONSTANTS.WORKOUT.NAME,
      },
    },
    {
      path: CIRCLE_ROUTE_CONSTANTS.LEADERBOARD.RELATIVE_PATH,
      element: <CircleLeaderboard />,
      handle: {
        pageName: CIRCLE_ROUTE_CONSTANTS.LEADERBOARD.NAME,
      },
    },
    {
      path: CIRCLE_ROUTE_CONSTANTS.DOWNLOAD_APP.RELATIVE_PATH,
      element: <MathgymDownloadApp />,
      handle: {
        pageName: CIRCLE_ROUTE_CONSTANTS.DOWNLOAD_APP.NAME,
      },
    },
  ],
};
